module.exports = __webpack_public_path__ + "static/img/line-shopping-v6.bef7544.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/btn_marketplace/line-shopping-v6.gif
// module id = eu6N
// module chunks = 134